import { checkUserType } from "../../utils/helper"
import { Navigate } from "react-router-dom"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { showToast } from "../../redux/guest-slices/other.slice"

function NoSpecialist({ children }) {
  const dispatch = useDispatch()
  const userType = checkUserType()

  useEffect(() => {
    if (userType === "specialist") {
      dispatch(
        showToast({
          type: "info",
          message: "This page is only available for Members.",
        })
      )
    }
  }, [userType, dispatch])

  if (userType === "specialist") {
    return <Navigate to="/specialist/profile" replace />
  }
  return children
}

export default NoSpecialist
